module.exports = __webpack_public_path__ + "static/img/shipinhuiyi.bec9d70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/shipinhuiyi.png
// module id = aV07
// module chunks = 24